import { render, staticRenderFns } from "./favsButton.vue?vue&type=template&id=78137ddb&scoped=true&"
import script from "./favsButton.vue?vue&type=script&lang=js&"
export * from "./favsButton.vue?vue&type=script&lang=js&"
import style0 from "./favsButton.vue?vue&type=style&index=0&id=78137ddb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78137ddb",
  null
  
)

export default component.exports